import Update_Icon from "../images/table/Update_icon.svg";
import Reset_Icon from "../images/table/Reset_icon.svg";
import Delete_Icon from "../images/table/Delete_icon.svg";
import Update_2_Icon from "../images/table/Update_new.svg";
import Reset_2_Icon from "../images/table/reset_pass_new.svg";
import Delete_2_Icon from "../images/table/delete_new.svg";
export const FLEET_USER_ROW_ACTIONS = {
  updateUser: {
    id: "update",
    label: "Update",
    icon: Update_2_Icon,
    path: "/user/AddUser",
    permission: { apiPath: "/api/user", action: "PUT" },
  },
  resetUserPassword: {
    id: "reset",
    label: "Reset Password",
    icon: Reset_2_Icon,
    path: "",
    permission: { apiPath: "/api/user/password", action: "PATCH" },
  },
  deleteUser: {
    id: "delete",
    label: "Delete",
    className: "delete",
    icon: Delete_2_Icon,
    path: "",
    permission: { apiPath: "/api/user", action: "DELETE" },
  },
};

export function computeFleetUserMetric(metricKey, userData = []) {
  const users = Array.isArray(userData) ? userData : [];

  switch (metricKey) {
    case "totalUsers":
      return users.length;
    case "activeUsers":
      return users.filter((user) => user.role && user.role !== "N/A").length;
    case "inactiveUsers":
      return users.filter((user) => !user.role || user.role === "N/A").length;
    default:
      return 0;
  }
}
